import LoadingButton from "@/components/common/form/loading-button";
import { UPDATE_ORGANIZATION } from "@/gql/organization";
import { CONNECT_CAFE24_TOKEN } from "@/gql/site";
import { IOrganization } from "@/types/organization";
import { handleApolloError } from "@/utils/handle-form";
import { useMutation } from "@apollo/client";
import {
  IConnectCafe24TokenMutation,
  IConnectCafe24TokenMutationVariables,
  IUpdateOrganizationMutation,
  IUpdateOrganizationMutationVariables,
} from "@shared/common/types/api-private/generated/graphql";
import React, { useCallback, useState } from "react";

interface ICafe24OnboardingScriptProps {
  currentOrganization: IOrganization;
  publicId: string;
  onChangeStep: (step: number) => void;
}

const Cafe24OnboardingScript = ({
  currentOrganization,
  publicId,
  onChangeStep,
}: ICafe24OnboardingScriptProps) => {
  const [installScriptLoading, setInstallScriptLoading] = useState(false);

  const [updateTeam] = useMutation<
    IUpdateOrganizationMutation,
    IUpdateOrganizationMutationVariables
  >(UPDATE_ORGANIZATION);

  const [connectCafe24Token] = useMutation<
    IConnectCafe24TokenMutation,
    IConnectCafe24TokenMutationVariables
  >(CONNECT_CAFE24_TOKEN, { onError: handleApolloError });

  const installScript = useCallback(async () => {
    onChangeStep(2.5);

    try {
      setInstallScriptLoading(true);
      await Promise.all([
        new Promise((resolve) => setTimeout(resolve, 2500)),
        connectCafe24Token({
          variables: { sitePublicId: publicId },
        }),
      ]);
      // step 변경
      await updateTeam({
        variables: {
          organizationId: currentOrganization.id,
          object: { onboardStep: 70 },
        },
      });
      onChangeStep(3);
    } finally {
      setInstallScriptLoading(false);
    }
  }, [
    connectCafe24Token,
    currentOrganization.id,
    onChangeStep,
    publicId,
    updateTeam,
  ]);

  return (
    <div>
      <div className="flex center-center">
        <div className="px-4 py-1 text-base rounded-2xl bg-cb-gray-100 text-cb-gray-900">
          <div className="p-4">
            <div className="text-center">
              개발자의 도움 없이 아래의 버튼을 클릭하여
            </div>
            <div className="text-center">내 Cafe24 사이트에</div>
            <div className="text-center">코드앤버터 스크립트를 설치하세요!</div>
            <div className="mt-8">
              <LoadingButton
                theme="primary"
                block
                onClick={installScript}
                loading={installScriptLoading}
                data-gtm-id="cafe24_install_script"
              >
                1초만에 코드앤버터 스크립트 설치
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Cafe24OnboardingScript);
